const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function eventListenerUrl(sessionCode, origin = window.location.origin) {
    return `${origin}/listener?code=${encodeURIComponent(sessionCode)}`;
}

export function eventHostUrl(runtimeId, eventId, sessionId) {
    const params = new URLSearchParams({ runtime: runtimeId, mode: 'events', source: 'events' });
    if (UUID.test(eventId) && UUID.test(sessionId)) {
        params.set('eventId', eventId);
        params.set('sessionId', sessionId);
    }
    return `/host?${params}`;
}

export function eventHostBackDestination(eventId, sessionId) {
    return UUID.test(eventId) && UUID.test(sessionId)
        ? `/events/${eventId}/sessions/${sessionId}`
        : '/events';
}
